import React from 'react';
import cn from 'classnames';
import { Link } from 'gatsby';

import logo from '@images/Ein-Sof-Advisors-Logo--Inverse.svg';
import links from '@data/links.json';
import ClientLoginMenu from '@components/ClientLoginMenu/ClientLoginMenu';
import FacebookIcon from '@images/icons/24/facebook-icon.inline.svg';
import TwitterIcon from '@images/icons/24/twitter-icon.inline.svg';
import InstagramIcon from '@images/icons/24/instagram-icon.inline.svg';
import LinkedinIcon from '@images/icons/24/linkedin-icon.inline.svg';
import * as css from './Footer.module.css';

const Footer = ({ ...props }) => {
  const defaultDisclosure = `Ein Sof Advisors, LLC (dba Ein Sof Advisors, “Ein Sof”) is a
  Registered Investment Advisor with the State of Florida with its
  primary office in Boca Raton, Florida. Information on this website
  does not involve the rendering of personalized investment advice, but
  is limited to the dissemination of general information on products and
  services. A professional adviser should be consulted before
  implementing any of the options presented. Information on this website
  is not an offer to buy or sell, or a solicitation of any offer to buy
  or sell the securities mentioned herein.`;

  const disclosure = props.disclosure || defaultDisclosure;

  return (
    <footer className={css.footer}>
      <section className={css.footer__main}>
        <div className="l-container">
          <div className="lg:flex lg:items-center">
            <nav className={css.footerNav}>
              <Link
                className={cn(css.footerNav__item, 'md:hidden')}
                to={links.home}
                activeClassName="text-brand-primary"
              >
                Home
              </Link>
              <Link
                className={css.footerNav__item}
                to={links.ourPhilosophy}
                activeClassName="text-brand-primary"
              >
                Our Philosophy
              </Link>
              <Link
                className={css.footerNav__item}
                to={links.financialPlanning}
                activeClassName="text-brand-primary"
              >
                Financial Planning
              </Link>
              <Link
                className={css.footerNav__item}
                to={links.investmentManagement}
                activeClassName="text-brand-primary"
              >
                Investment Management
              </Link>
              <Link
                className={css.footerNav__item}
                to={links.education}
                activeClassName="text-brand-primary"
              >
                Education
              </Link>
              <Link
                className={css.footerNav__item}
                to={links.contact}
                activeClassName="text-brand-primary"
              >
                Contact
              </Link>
              <div className={cn(css.footerNav__clientLogin, 'md:hidden')}>
                <ClientLoginMenu footer />
              </div>
            </nav>
            <Link to={links.home}>
              <img
                className={css.footer__logo}
                src={logo}
                alt="Ein Sof Advisors logo"
              />
            </Link>
          </div>

          <div className={css.footer__subBar}>
            <div className="lg:flex-grow">
              <div className={css.footerSocial}>
                <a
                  className={css.footerSocial__item}
                  href={links.facebook}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <FacebookIcon fill="white" />
                </a>
                <a
                  className={css.footerSocial__item}
                  href={links.twitter}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <TwitterIcon fill="white" />
                </a>
                <a
                  className={css.footerSocial__item}
                  href={links.instagram}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <InstagramIcon fill="white" />
                </a>
                <a
                  className={css.footerSocial__item}
                  href={links.linkedin}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <LinkedinIcon fill="white" />
                </a>
              </div>
            </div>

            <div className={css.footerDesktopClientLogin}>
              <ClientLoginMenu footer />
            </div>
          </div>
        </div>
      </section>

      <section className={css.footer__disclosure}>
        <div className="l-container opacity-50 text-xs">
          <div className="flex">
            &copy; {new Date().getFullYear()} Ein Sof Advisors, LLC
            <span className="mx-3">•</span>
            <Link to={links.privacyPolicy} className="hover:underline">
              Privacy Policy
            </Link>
          </div>
          <p className="mt-3">{disclosure}</p>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
